module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_5.bad69b65c41ae853e68db611d6fcab77.png";